module.exports = {
  "wxc-city": {
    "position": "fixed",
    "width": "750",
    "backgroundColor": "#F2F3F4"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-3c56dcfd!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/wxc-city/index.vue
// module id = 170
// module chunks = 0 1